import React from 'react';
import { Card, CardMedia, CardContent, Typography, Box } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { INewsReponse } from '../../../model/base/response/news-response';
import dayjs from 'dayjs';
import { useNavigate } from '../../../hooks/useNavigate';

interface NewsCardProps {
  news: INewsReponse;
}

export default function NewsCard({ news }: NewsCardProps) {
  const [imageError, setImageError] = React.useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/noticia/${news.id}`);
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: 6,
        },
      }}
    >
      {news.urlImageEmphasis && !imageError ? (
        <CardMedia
          component="img"
          height="200"
          image={news.urlImageEmphasis}
          alt={news.title}
          onError={() => setImageError(true)}
          sx={{
            objectFit: 'cover',
          }}
        />
      ) : (
        <Box
          sx={{
            height: 200,
            backgroundColor: 'grey.200',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Sem imagem
          </Typography>
        </Box>
      )}

      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography
          gutterBottom
          variant="h6"
          component="h3"
          sx={{
            fontWeight: 600,
            fontSize: '1.1rem',
            lineHeight: 1.4,
            color: 'text.primary',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            mb: 'auto',
          }}
        >
          {news.title}
        </Typography>

        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <CalendarTodayIcon sx={{ fontSize: '0.875rem', color: 'text.secondary' }} />
            <Typography variant="caption" color="text.secondary">
              {news.publishedDate
                ? dayjs(news.publishedDate).format('DD/MM/YYYY')
                : dayjs(news.date).format('DD/MM/YYYY')}
            </Typography>
          </Box>
          <Typography
            variant="caption"
            color="primary"
            sx={{
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
            }}
          >
            Leia mais →
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
